import { render, staticRenderFns } from "./UpdateTask.vue?vue&type=template&id=059c498d&scoped=true"
import script from "./UpdateTask.vue?vue&type=script&lang=js"
export * from "./UpdateTask.vue?vue&type=script&lang=js"
import style0 from "./UpdateTask.vue?vue&type=style&index=0&id=059c498d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059c498d",
  null
  
)

export default component.exports